// extracted by mini-css-extract-plugin
export default {"backgroundBtn":"AddCartBtn_backgroundBtn__td8XL"};